import { createLoader, useRead } from '@spotify-internal/creator-data-loading';
import { Logger } from '@mrkt/features/Platform';
import { webgateFetch, WEBGATE_DOMAIN } from '../../shared/lib/api';
import { withHooks } from '../../shared/lib/withHooks';

export const endpoint = `${WEBGATE_DOMAIN}/s4x-me/v0/me`;

const eventName = 'load-currentuser';

export const currentUserLoader = createLoader(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async (_key: 0) => {
    try {
      const response = await webgateFetch(endpoint);
      if (response.status === 401) return null;
      if (!response.ok) throw new Error(`${response.status} ${response.url}`);
      const data = (await response.json()) as Data;
      const formatted = { email: data.loginEmail, ...data } as const;
      Logger.logSuccess(eventName);
      return formatted;
    } catch (error) {
      Logger.logError(eventName, error);
      throw error;
    }
  },
  {
    cacheKeyFn: () => 0,
  },
);

export function useCurrentUser() {
  return useRead(currentUserLoader, 0);
}

export const withCurrentUser = withHooks(() => ({
  currentUser: useCurrentUser(),
}));

type Data = {
  name: string;
  username: string;
  loginEmail: string;
  imageUrl: string;
  largeImageUrl: string;
  hasAccess: boolean;
  hasLabelOnlyAccess: boolean;
  partnerIds: {
    google: string;
    qualaroo: string;
  };
  needsToAcceptTerms?: boolean;
};
